<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import { showAlertDisconnected } from '@/event/account/alert/showAlertDisconnected'
import {
    messageAlertDisconnectEmptyHappy,
    messageAlertDisconnectHappy
} from '@/happyTheme/event/messageDisconnect/messageAlertDisconnectHappy'
import { useI18n } from 'vue-i18n'

const { t, te } = useI18n()

// Translate a backend key if it exists in the i18n catalog,
// otherwise return the raw string (fallback for legacy messages).
function tr(key: string): string {
    if (!key) return ''
    return te(key) ? t(key) : key
}

function toggleAlertMessageDisconnectHappy() {
    messageAlertDisconnectHappy.value = messageAlertDisconnectEmptyHappy
}
</script>

<template>
    <section class="section-modal-message-disconnect-happy">
        <section
            class="section-overlay-message-disconnect-happy"
            @click="toggleAlertMessageDisconnectHappy"
        ></section>

        <Transition
            name="transition-message-disconnect"
            enter-active-class="transition-all duration-300 ease-in-out"
            leave-active-class="transition-all duration-300 ease-in-out "
            enter-from-class="opacity-0 translate-x-full"
            enter-to-class="opacity-100 translate-x-0"
            leave-from-class="opacity-100 translate-x-0"
            leave-to-class="opacity-0 translate-x-full"
            :key="'MessageDisconnect'"
        >
            <section
                class="section-message-disconnect-happy"
                v-if="showAlertDisconnected"
            >
                <div
                    class="div-content-message-disconnect-happy"
                    :class="`div-content-message-disconnect-happy-${messageAlertDisconnectHappy.class}`"
                >
                    <ButtonClose
                        :function="toggleAlertMessageDisconnectHappy"
                        :hover-color="
                            messageAlertDisconnectHappy.class === 'success'
                                ? 'success-happy'
                                : 'error-happy'
                        "
                    />
                </div>

                <div
                    class="div-second-content-message-disconnect-happy"
                    :class="messageAlertDisconnectHappy.class"
                >
                    <p>{{ tr(messageAlertDisconnectHappy.message) }}</p>
                </div>
            </section>
        </Transition>
    </section>
</template>

<style scoped>
.section-modal-message-disconnect-happy {
    @apply fixed z-30 w-full h-full flex justify-center;
}

.section-overlay-message-disconnect-happy {
    @apply w-full h-full;
}

.section-message-disconnect-happy {
    @apply z-10 absolute w-72  flex flex-col justify-center;
    /* @apply mt-52; */
    @apply bottom-10 right-2;
}

.div-content-message-disconnect-happy {
    @apply w-full h-full rounded-t-md p-2 bg-green-light-happy flex justify-end;
}

.div-second-content-message-disconnect-happy {
    @apply w-full h-full rounded-b-md pt-3 p-2 text-center;
}

.error {
    @apply bg-border-red-happy-light text-bg-happy-light font-semibold;
    /* refactored: ifo-dark zarif dark-pill toast — solid red kutu yerine
       dark card + danger border + danger text + subtle red glow. */
    @apply happy-ifo-dark:bg-t-card
           happy-ifo-dark:text-t-danger
           happy-ifo-dark:border
           happy-ifo-dark:border-t-danger/40
           happy-ifo-dark:shadow-[0_8px_24px_-8px_rgba(248,81,73,0.35)]
           happy-ifo-dark:rounded-b-xl;
}
.div-content-message-disconnect-happy-error {
    @apply bg-header-red-happy;
    /* refactored: ifo-dark'ta header bant değil, aynı kartın üst kısmı —
       danger border + transparent bg, X sağ üstte sade dursun. */
    @apply happy-ifo-dark:bg-t-card
           happy-ifo-dark:border-x
           happy-ifo-dark:border-t
           happy-ifo-dark:border-t-danger/40
           happy-ifo-dark:rounded-t-xl
           happy-ifo-dark:border-b-0;
}

.success {
    /* refactored: per-theme success bg -> semantic accent */
    @apply bg-t-accent text-t-on-accent font-semibold;
    /* refactored: ifo-dark zarif dark-pill toast — solid amber kutu
       ("içler acısı") yerine dark card + amber border + amber text +
       subtle amber glow. Ekle butonunun pill tarzıyla uyumlu. */
    @apply happy-ifo-dark:bg-t-card
           happy-ifo-dark:text-t-accent
           happy-ifo-dark:border
           happy-ifo-dark:border-t-accent/40
           happy-ifo-dark:shadow-[0_8px_24px_-8px_rgba(212,160,23,0.35)]
           happy-ifo-dark:rounded-b-xl;
}

.div-content-message-disconnect-happy-success {
    /* refactored: per-theme success bg -> semantic accent */
    @apply bg-t-accent text-t-on-accent;
    /* refactored: ifo-dark'ta header amber bant değil — kartın üst kısmı,
       amber border + transparent bg. */
    @apply happy-ifo-dark:bg-t-card
           happy-ifo-dark:border-x
           happy-ifo-dark:border-t
           happy-ifo-dark:border-t-accent/40
           happy-ifo-dark:rounded-t-xl
           happy-ifo-dark:border-b-0;
}

@media screen and (min-width: 500px) {
    .section-message-disconnect-happy {
        @apply right-8;
    }
}
</style>
